module.exports = __webpack_public_path__ + "img/icon-pfeil-link_schwarz.d7c87516.svg";